//DOC: https://cv-vinbdi.atlassian.net/wiki/spaces/VinDrPACs/pages/235602261/Permisssion+Matrix

export const PERMISSIONS = Object.freeze({
  page: {
    admin_settings: 'admin_settings',
    user_settings: 'user_settings',
    view_dashboard: 'view_dashboard',
    view_order: 'view_order',
    view_report: 'view_report',
    view_sharedlist: 'view_sharedlist',
    view_studylist: 'view_studylist',
    view_worklist: 'view_worklist',
    view_assignedlist: 'view_assignedlist',
    view_viewer: 'view_viewer',
    view_patient: 'view_patient',
    view_upload: 'view_upload',
    monitoring_hl7: 'view_monitoringhl7',
    monitoring_sign_digital: 'view_monitoringsigndigital',
    monitoring_remote_consultation: 'view_monitoringremoteconsultation',
  },
  layout: {
    share: 'layout.share',
  },
  template: {
    share: 'template.share',
    element_admin: 'element.admin',
    structurereport_admin: 'structurereport.admin',
    structurereport_share: 'structurereport.share',
  },
  order: {
    create: 'order.create',
    share: 'order.share', //?
    update: 'order.update',
    delete: 'order.delete',
    assign: 'order.assign',
    his_order: 'order.his-order',
    view: 'view_order',
    priority: 'order.priority',
    note: 'order.note',
    changestatus: 'order.changestatus',
    deliverreport: 'order.deliverreport',
    qms: 'order.qms',
    receive: 'order.receive',
    receiveqms: 'order.receiveqms',
  },
  report: {
    create: 'report.create',
    approved: 'report.approved',
    update: 'report.update',
    print: 'report.print',
    keyimage: 'report.keyimage',
    capture: 'report.capturevideo',
    structure: 'report.structure',
    assign: 'report.assign',
    sign_digital_create: 'report.signdigitalcreate',
  },
  studylist: {
    delete: 'studylist.delete',
    export: 'studylist.export',
    match: 'studylist.match',
    note: 'studylist.note',
    report: 'studylist.report',
    share: 'studylist.share',
    upload: 'studylist.upload',
    attachment_add: 'studylist.attachment.add',
  },
  worklist: {
    share: 'worklist.share',
    report: 'worklist.report',
    attachment: 'worklist.attachment',
    hisorderlist: 'worklist.hisorderlist', //?
    order_edit: 'worklist.order.edit',
    qms: 'worklist.qms',
  },
  assigned: {
    admin_assignedlist: 'admin_assignedlist',
  },
  dashboard: {
    admin_dashboard: 'admin_dashboard',
  },
  viewer: {
    delete_study: 'viewer.deletestudy',
    keyimage: 'viewer.keyimage',
    download: 'viewer.download',
    record_annotation: 'viewer.recordannotation',
  },
  patient: {
    add: 'patient.add',
    update: 'patient.update',
    delete: 'patient.delete',
    resetpassword: 'patient.resetpassword',
    attachment: 'patient.attachment',
  },
  monitoring: {
    hl7messageresend: 'monitoring.hl7messageresend',
    hl7messagedelete: 'monitoring.hl7messagedelete',
    signdigitalresend: 'monitoring.signdigitalresend',
    signdigitalrevoke: 'monitoring.signdigitalrevoke',
    signdigitaldelete: 'monitoring.signdigitaldelete',
  },
  remoteconsultation: {
    create: 'remoteconsultation.create',
    edit: 'remoteconsultation.edit',
    cancel: 'remoteconsultation.cancel',
    note: 'remoteconsultation.note',
    delete: 'remoteconsultation.create',
  },
  qms: {
    profile: 'qms.profile',
    update: 'qms.update',
  },
});

export enum ROLES {
  Administrator = 'vindr-administrator',
  Radiologist = 'vindr-radiologist',
  Technologist = 'vindr-technologist',
  Moderator = 'vindr-moderator',
  Patient = 'vindr-patient',
}
